import React, { useState, useEffect } from 'react';
import config from '../../config/apiConfig';
import { imprimirStockCritico } from '../../services/Impresion';

const ReporteStock = () => {
    const [productos, setProductos] = useState([]);
    const [loading, setLoading] = useState(false);

    const cargarStock = async () => {
        setLoading(true);
        try {
            const token = localStorage.getItem("token");
            const res = await fetch(`${config.api_url}/api/reportes/stock_critico`,{headers: { 'Content-Type': 'application/json', 'token': token }});
            const data = await res.json();
            setProductos(data.stock_critico || []);
        } catch (e) { console.error(e); }
        finally { setLoading(false); }
    };

      
                

    const cleanNum = (num) => {
        const n = Number(num);
        // Si es entero, devuelve el entero, si no, lo formatea a 1 decimal
        return n % 1 === 0 ? n.toFixed(0) : n.toFixed(1);
    };

    useEffect(() => { cargarStock(); }, []);

    return (
        <div className="card shadow-sm border-0 rounded-lg p-4">
            <h4 className="font-weight-bold mb-4 text-danger">
                <i className="fas fa-exclamation-triangle mr-2"></i> Stock Crítico
            </h4>

            {loading ? (
                <div className="text-center py-4"><i className="fas fa-spinner fa-spin"></i></div>
            ) : productos.length === 0 ? (
                <div className="text-center py-4 text-success font-weight-bold">
                    <i className="fas fa-check-circle fa-2x d-block mb-2"></i> Todo el stock está bien.
                </div>
            ) : (
                <div className="table-responsive">
                    <table className="table table-hover">
                        <thead className="thead-light small text-uppercase">
                            <tr>
                                <th>Producto</th>
                                <th className="text-center">Stock Actual</th>
                                <th className="text-center">Stock Mínimo</th>
                            </tr>
                        </thead>
                        <tbody>
                            {productos.map((p, i) => (
                                <tr key={i} className={p.stock_actual <= 0 ? 'table-danger' : 'table-warning'}>
                                    <td className="font-weight-bold">{p.nombre}</td>
                                    {/* 🚩 ACA APLICAMOS EL CLEANNUM */}
                                    <td className="text-center font-weight-bold">{cleanNum(p.stock_actual)}</td>
                                    <td className="text-center text-muted">{cleanNum(p.stock_minimo)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}

            <div className="card-footer bg-white text-center p-3">
                <button
                    className="btn btn-dark btn-lg shadow-sm"
                    onClick={() => imprimirStockCritico(productos)}
                >
                    <i className="fas fa-print mr-2"></i> IMPRIMIR REPORTE
                </button>
            </div>
        </div>
    );
};
export default ReporteStock;